<template>
  <div class="logo" @click="redirect">
    <img class="icon" src="~@assets/images/sidebar/header-logo-icon.png" alt="logo">
    <img class="text" src="~@assets/images/sidebar/header-logo-text.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    title: {
      type: String,
      default: 'IS - RPA',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  methods: {
    redirect () {
      window.location.href = this.$config.url.mallUrl
    }
  }
}
</script>
<style lang="less" scoped>
.logo{
  position: relative;
  height: 64px;
  line-height: 64px;
  background: #222;
  padding-left: 24px;
  //text-align: center;
  cursor: pointer;
  -webkit-transition: all .3s;
  transition: all .3s;
  overflow: hidden;
  .icon{
    width: 50px;
    height: 35px;
  }
  .text{
    width: 80px;
    height: 24px;
    padding-left: 10px;
  }
}
.ant-layout-sider-collapsed{
  .logo{
    text-align: center;
    padding-left: 0;
  }
}
</style>
